import { C } from "../common/theme";

/** Series colours for x-charts, in order: ink, leaf, coral, moss, warm grey. */
export const CHART_COLORS = [C.ink, C.leaf, C.coral, C.moss, "#A89F96", C.coralText];

export const chartSx = {
  "& .MuiChartsAxis-line, & .MuiChartsAxis-tick": { stroke: C.line2 },
  "& .MuiChartsAxis-tickLabel": { fill: C.muted, fontSize: 11 },
  "& .MuiChartsGrid-line": { stroke: C.line },
  "& .MuiChartsLegend-label": { fontSize: 12 },
};
